import { render, staticRenderFns } from "./InstructionIcon.vue?vue&type=template&id=80bf0e3a&scoped=true"
import script from "./InstructionIcon.vue?vue&type=script&lang=js"
export * from "./InstructionIcon.vue?vue&type=script&lang=js"
import style0 from "./InstructionIcon.vue?vue&type=style&index=0&id=80bf0e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bf0e3a",
  null
  
)

export default component.exports